<div class="task-dialog" role="dialog" aria-modal="true">
  <!-- Header -->
  <div class="task-dialog__header">
    <h2 class="task-dialog__title">{{ title() }}</h2>

    <button type="button" class="task-dialog__icon-btn" aria-label="Close dialog" (click)="cancel()">✕</button>
  </div>

  <!-- Content -->
  <div class="task-dialog__content">
    <div class="task-dialog__section-title">Alert</div>

    <form class="task-dialog__form" [formGroup]="form">
      <!-- Program select -->
      <div class="task-dialog__row">
        <div class="field">
          <!-- <label class="field__label" for="program">Program</label> -->

          @if (isCreate()) {
          <dr-ops-stream-ui-app-dropdown
            id="program"
            formControlName="programIds"
            [searchable]="true"
            [disabled]="isViewOnly()"
            [disabledOpacity]="1"
            [multiple]="true"
            placeholder="Program"
            [closeOnOutsideClick]="true"
            [options]="programOptions()"
            floatingLabel="Program"
            [panelMaxHeightRem]="24"
          ></dr-ops-stream-ui-app-dropdown>

          @if (form.controls.programIds.touched && form.controls.programIds.invalid) {
          <div class="field__error">At least one program is required</div>
          } } @else {
          <dr-ops-stream-ui-app-dropdown
            id="program"
            formControlName="programId"
            [searchable]="true"
            [disabled]="isViewOnly()"
            [disabledOpacity]="1"
            placeholder="Program"
            [closeOnOutsideClick]="true"
            [options]="programOptions()"
            floatingLabel="Program"
            [panelMaxHeightRem]="24"
          ></dr-ops-stream-ui-app-dropdown>

          @if (form.controls.programId.touched && form.controls.programId.invalid && !isViewOnly()) {
          <div class="field__error">Program is required</div>
          } }
        </div>
        <div class="field">
          <!-- <label class="field__label" for="timezone">Timezone</label> -->

          <dr-ops-stream-ui-app-dropdown
            id="window"
            formControlName="window"
            [disabled]="isViewOnly()"
            [disabledOpacity]="1"
            placeholder="Window"
            [closeOnOutsideClick]="true"
            [options]="windowOptions()"
            floatingLabel="Window"
            [panelMaxHeightRem]="24"
          ></dr-ops-stream-ui-app-dropdown>

          @if (form.controls.window.touched && form.controls.window.invalid) {
          <div class="field__error">Window is required</div>
          }
        </div>
      </div>

      <div class="task-dialog__section-title">Set up date and time</div>

      <div class="task-dialog__row">
        <div class="field mb0">
          <label class="field__label" for="time">From</label>
          <input id="startDate" class="input" type="datetime-local" formControlName="startDate" placeholder="Date and time" [readOnly]="isViewOnly()" />
          @if (form.controls.startDate.touched && form.controls.startDate.invalid && !isViewOnly()) {
          <div class="field__error">Start Date is required</div>
          } @if (startEndInvalid() && !isViewOnly()) {
          <div class="field__error">Start date must be before the end date</div>
          }
        </div>
        <div class="field mb0">
          <label class="field__label" for="time">To</label>
          <input id="endDate" class="input" type="datetime-local" formControlName="endDate" placeholder="Date and time" [readOnly]="isViewOnly()" />
          @if (form.controls.endDate.touched && form.controls.endDate.invalid && !isViewOnly()) {
          <div class="field__error">End Date is required</div>
          } @if (startEndInvalid() && !isViewOnly()) {
          <div class="field__error">Please adjust the dates</div>
          }
        </div>
        <div class="field">
          <!-- <label class="field__label" for="timezone">Timezone</label> -->

          <dr-ops-stream-ui-app-dropdown
            id="timezone"
            formControlName="timezone"
            [disabled]="isViewOnly()"
            [disabledOpacity]="1"
            placeholder="Timezone"
            [closeOnOutsideClick]="true"
            [options]="timezoneWorldClockOptions()"
            floatingLabel="Timezone"
            [panelMaxHeightRem]="24"
          ></dr-ops-stream-ui-app-dropdown>

          @if (form.controls.timezone.touched && form.controls.timezone.invalid) {
          <div class="field__error">Timezone is required</div>
          }
        </div>
      </div>

      <div class="task-dialog__section-title">Alert</div>
      <!-- Notes -->
      <div class="field field--full">
        <!-- <label class="field__label" for="notes">Notes</label> -->
        <textarea id="notes" class="textarea" formControlName="notes" placeholder="Add notes" rows="4" [readOnly]="isViewOnly()"></textarea>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <div class="task-dialog__footer">
    <button type="button" class="btn btn--secondary" (click)="cancel()">Cancel</button>

    @if (!isViewOnly()) {
    <button type="button" class="btn btn--primary" [disabled]="!canSubmit()" (click)="submit()">{{ confirmLabel() }}</button>
    }
  </div>
</div>
